<div class="input-data-container">
  <div class="input-container">
    <input #inputText type="text"
      class="input-data rbv-field"
      [ngClass]="{'warning-bordered': warningFlag, 'error-bordered': errorFlag}"
      [(ngModel)]="inputValue"
      [name]="name"
      [disabled]="disabled"
      [placeholder]="placeholder"
      (blur)="onBlur()"
      (focus)="onFocus()"
      (paste)="onPaste($event)"
      (keypress)="onKeyPress($event)"
      (ngModelChange)="valueChanged()"
      (keydown.enter)="accept()"
      [minLength]="minLength"
      [maxLength]="maxLength"
      (keydown.escape)="clear()"
      (focusout)="focusOut()"
      [required]="required"
      [readonly]="readonly"
      [mask]="inputMask ? inputMask : ''"/>

    <div class="actions-wrapper" *ngIf="valueChangedFlag && showButton">
      <a (click)="accept()" class="accept">
        <i class="fa fa-check" aria-hidden="true"></i>
      </a>
      <a (click)="clear()" class="cancel">
        <i class="fa fa-times" aria-hidden="true"></i>
      </a>
    </div>
  </div>
</div>

<small *ngIf="errorFlag && !warningFlag" class="form-text">
  <span class="text-danger">Input must be at least
    minimum of {{minLength}} and maximum of {{maxLength}}</span>
</small>

<small *ngIf="email && warningFlag && !errorFlag" class="form-text">
  <span class="text-warning">This email cannot be edit</span>
</small>
